// Vendor Libs
import moment from 'moment-timezone';
import {forEach} from 'lodash';

const defaultDateFormat = 'MM/DD/YY';
const defaultDurationFormat = 'h m s';
const defaultDurationUnit = 'seconds';
const defaultParseFormats = [moment.ISO_8601, 'YYYY-MM-DD'];
const defaultTimezoneFormat = 'MM/DD/YYYY hh:mm:ss A z';
const durationSplitRegex = /[\s]*([\d]+)[\s]*([dhms])[\s]*/i;
const durationSplitGroupRegex = /[\s]*([\d]+[\s]*[dhms])[\s]*/i;

export function formatDate(dateString, format = defaultDateFormat, parseFormats = defaultParseFormats, invalidDate) {
    const date = parseDate(dateString, parseFormats);

    return date !== null ? date.format(format) : invalidDate;
}

export function formatTimezone(
    dateString,
    format = defaultTimezoneFormat,
    timezone,
    parseFormats = defaultParseFormats,
    invalidDate
) {
    const date = parseDate(dateString, parseFormats);
    const formatTimezone = timezone || moment.tz.guess();

    return date !== null ? date.tz(formatTimezone).format(format) : invalidDate;
}

export function formatDuration(
    durationString,
    format = defaultDurationFormat,
    durationUnit = defaultDurationUnit,
    invalidDuration
) {
    const results = [];
    const duration = moment.duration(durationString, durationUnit);

    forEach(format.split(' '), unit => {
        const unitValue = duration.get(unit);

        if (unitValue) {
            results.push(`${unitValue}${unit}`);
        }
    });

    return results.length ? results.join(' ') : invalidDuration;
}

export function isValidDate(date, formats = defaultParseFormats) {
    // Use strict parsing
    return moment(date, formats, true).isValid();
}

export function isValidDuration(durationString) {
    return parseDuration(durationString) !== null;
}

export function parseDate(dateString, formats = defaultParseFormats) {
    return isValidDate(dateString, formats) ? moment(dateString, formats) : null;
}

export function parseDuration(durationString = '') {
    let durationParts = {};
    let result;

    if (durationString !== null) {
        forEach(durationString.split(durationSplitGroupRegex), part => {
            if (part !== '') {
                const match = durationSplitRegex.exec(part);

                if (match !== null && match.length > 2) {
                    const unit = match[2].toLowerCase();

                    if (durationParts[unit]) {
                        durationParts = {};
                        return false;
                    }

                    durationParts[unit] = match[1];
                } else {
                    durationParts = {};
                    return false;
                }
            }
        });
    }

    result = moment.duration(durationParts);

    return result.as(defaultDurationUnit) > 0 ? result : null;
}

export function parseDurationAs(durationString, unit = defaultDurationUnit) {
    const duration = parseDuration(durationString);

    return duration !== null ? duration.as(unit) : null;
}
